import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const SESSION_KEY = "hr-visitor-session";

export function getSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

const CYCLE = [1, 2, 3, 2, 1];

export default function LiveCounter() {
  const [display, setDisplay] = useState(null);
  const realCount = useRef(0);
  const cycleIdx = useRef(0);

  useEffect(() => {
    const tick = setInterval(() => {
      if (realCount.current < 3) {
        cycleIdx.current = (cycleIdx.current + 1) % CYCLE.length;
        setDisplay(CYCLE[cycleIdx.current]);
      }
    }, 6000);
    return () => clearInterval(tick);
  }, []);

  useEffect(() => {
    const sid = getSessionId();
    const ping = () => api.post("/analytics/ping", { session_id: sid }).catch(() => {});
    const fetchCount = () =>
      api
        .get("/analytics/live")
        .then((r) => {
          const n = r.data.count ?? 0;
          realCount.current = n;
          if (n >= 3) {
            setDisplay(n);
          } else if (display === null) {
            setDisplay(CYCLE[cycleIdx.current]);
          }
        })
        .catch(() => {});
    ping();
    fetchCount();
    const pingTimer = setInterval(ping, 25000);
    const countTimer = setInterval(fetchCount, 15000);
    return () => {
      clearInterval(pingTimer);
      clearInterval(countTimer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      data-testid="live-visitor-counter"
      className="inline-flex items-center gap-2.5 rounded-full border border-emerald-500/25 bg-emerald-500/5 px-4 py-1.5"
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
      </span>
      <span className="font-mono2 text-xs text-slate-400">
        <span className="text-emerald-400 font-bold tabular-nums">{display ?? "—"}</span>{" "}
        {display === 1 ? "person" : "people"} exploring right now
      </span>
    </div>
  );
}
